export const YOUTUBE_ICON = 'https://acko-cms.ackoassets.com/youtube_icon_0a80ef5b2e.svg'
export const TWITTER_ICON = 'https://acko-cms.ackoassets.com/twitter_icon_261c5f4801.svg'
export const INSTAGRAM_ICON = 'https://acko-cms.ackoassets.com/instagram_icon_cbade30ffb.svg'
export const FACEBOOK_ICON = 'https://acko-cms.ackoassets.com/facebook_icon_5c879268e1.svg'
export const WHITE_ARROW_DOWN = 'https://acko-cms.ackoassets.com/footer_arrow_down_white_a066cfa830.svg'
